'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ExternalContentCardSource = require('./ExternalContentCardSource.css');

var _ExternalContentCardSource2 = _interopRequireDefault(_ExternalContentCardSource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExternalContentCardSource = function ExternalContentCardSource(props) {
  return _react2.default.createElement(
    'div',
    {
      className: 'jsx-' + _ExternalContentCardSource2.default.__scopedHash + ' ' + 'root'
    },
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-' + _ExternalContentCardSource2.default.__scopedHash
      },
      props.text
    ),
    _react2.default.createElement('div', {
      className: 'jsx-' + _ExternalContentCardSource2.default.__scopedHash + ' ' + 'icon'
    }),
    _react2.default.createElement(_style2.default, {
      styleId: _ExternalContentCardSource2.default.__scopedHash,
      css: _ExternalContentCardSource2.default.__scoped
    })
  );
};

ExternalContentCardSource.propTypes = {
  text: _propTypes2.default.string.isRequired
};

exports.default = ExternalContentCardSource;